import React, { useEffect, useRef, useState } from "react";

import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography, createFilterOptions } from "@mui/material";
import {
  CreateManageWorkAction,
  DeleteManageWorkAction,
  GetAllManageWorkAction,
  UpdateManageWorkAction,
} from "../../../../redux/actions/ManageWorkAction";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import html2canvas from "html2canvas";
import ManagePrint from "../ManagePrint";

import jsPDF from "jspdf";
import axios from "axios";
import fileDownload from "js-file-download";
import { ToastContainer } from "react-toastify";
import { useDownloadExcel } from "react-export-table-to-excel";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useReactToPrint } from "react-to-print";
const Money = ({
  userData,
  Datee,
  setDatee,
  ManageWorkID,
  setManageWorkID,
  Requirework,
  setRequirework,
  GehaWork,
  setGehaWork,
  MenueWork,
  setMenueWork,
  Result,
  setResult,
  Notes,
  setNotes,
  SelectedFile,
  setSelectedFile,
  Description,
  setDescription,
  IsEdit,
  setIsEdit,
  Eye,
  setEye,
}) => {
  const [FileeBase64, setBase64] = useState("");
  const [loading, setLoading] = useState(true);
  const [Search, setSearch] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const myDivRefWorkcom = useRef();
  const tableRef = useRef("");

  const PageSize = 7;
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "ادارة العمل الاداري",
    sheet: "ادارة العمل الاداري",
  });
  const onPress = async (page) => {
    await dispatch(
      GetAllManageWorkAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setManageWorkID(itemid);
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteManageWorkAction(ManageWorkID));
    setLoading(false);
    setManageWorkID("");
    setshowDelete(false);
    setIsPress(false);
    setDatee("");
    setManageWorkID("");
    setRequirework("");
    setGehaWork("");
    setMenueWork("");
    setResult("");
    setNotes("");
    setSelectedFile("");
    setDescription("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };

  const ALL = useSelector((state) => state.ManageWorkR.GetManagework);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllManageWorkAction(`PageSize=${PageSize}`));
  }, []);

  useEffect(() => {
    dispatch(GetAllManageWorkAction(`SearchTerm=${Search}&PageSize=${100}`));
  }, [Search]);
  const handlePrint = useReactToPrint({
    content: () => myDivRefWorkcom.current,
  });
  const Update = (item) => {
    setRequirework(item.WantedWork || "");
    setResult(item.Result || "");
    setNotes(item.Note || "");
    setManageWorkID(item.Id);
    setSelectedFile(item.FileUrl);
    setDescription(item.FileDescription === null ? "" : item.FileDescription);
    setMenueWork(item.EmployeeName || "");
    setGehaWork(item.Destination || "");
    setDatee(item.Date);

    setIsEdit(true);
    setEye(false);
  };
  const HandleShow = (item) => {
    setRequirework(item.WantedWork || "");
    setResult(item.Result || "");
    setNotes(item.Note || "");
    setManageWorkID(item.Id);
    setSelectedFile(item.FileUrl);
    setDescription(item.FileDescription === null ? "" : item.FileDescription);
    setMenueWork(item.EmployeeName || "");
    setGehaWork(item.Destination || "");
    setDatee(item.Date);
    setIsEdit(false);
    setEye(true);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Datee === "" || Requirework === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (SelectedFile && SelectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.SubscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 عمل إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 عمل إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("WantedWork", Requirework);
    formData.append("Destination", GehaWork);
    formData.append("EmployeeName", MenueWork);
    formData.append("Result", Result);
    formData.append("Note", Notes);
    formData.append("FileDescription", Description);
    formData.append("File", SelectedFile);
    await dispatch(CreateManageWorkAction(formData));
    setDatee("");
    setManageWorkID("");
    setRequirework("");
    setGehaWork("");
    setMenueWork("");
    setResult("");
    setNotes("");
    setSelectedFile("");
    setDescription("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (Datee === "" || Requirework === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (SelectedFile && SelectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Id", ManageWorkID);
    formData.append("Date", Datee);
    formData.append("WantedWork", Requirework);
    formData.append("Destination", GehaWork);
    formData.append("EmployeeName", MenueWork);
    formData.append("Result", Result);
    formData.append("Note", Notes);
    formData.append("FileDescription", Description);
    formData.append("NewFile", SelectedFile);
    await dispatch(UpdateManageWorkAction(formData));
    setDatee("");
    setManageWorkID("");
    setRequirework("");
    setGehaWork("");
    setMenueWork("");
    setResult("");
    setNotes("");
    setSelectedFile("");
    setIsEdit(false);
    setDescription("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };

  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";

    if (userData.UsedSize >= userData.SubscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn"
      );
      return;
    }
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };
      reader.readAsDataURL(e.target.files[0]);
    };
    // }

    input.click();
  }
  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const res = useSelector((state) => state.ManageWorkR.AddManagework);
  const UP = useSelector((state) => state.ManageWorkR.UpdateManagework);
  const DEL = useSelector((state) => state.ManageWorkR.DeleteManagework);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, Admin Work added Successfully"
          ) {
            dispatch(GetAllManageWorkAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "Great, admin management updated Successfully"
          ) {
            dispatch(GetAllManageWorkAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage ===
              "Great, admin management deleted Successfully"
          ) {
            dispatch(GetAllManageWorkAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {" "}
                {Datee ? new Date(Datee).toLocaleDateString("en-GB") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                onChange={(e) => setDatee(e.target.value)}
                value={Datee}
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    العمل المطلوب
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={Requirework}
                onChange={(e) => setRequirework(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="جهة العمل"
                variant="outlined"
                value={GehaWork}
                onChange={(e) => setGehaWork(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="القائم بالعمل"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={MenueWork}
                onChange={(e) => setMenueWork(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="النتيجة"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                value={Result}
                onChange={(e) => setResult(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="ملاحظات"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                value={Notes}
                onChange={(e) => setNotes(e.target.value)}

                //   className="ww"
              />
            </div>{" "}
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="أرشيف المستندات"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {SelectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : SelectedFile}
                    target="blank"
                    download={SelectedFile.name}>
                    {SelectedFile.name ? (
                      SelectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>Attach File</div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}
            </div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {IsEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                العمل المطلوب<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                جهة العمل <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                النتيجة<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.Data && ALL.Data.length > 0
              ? ALL.Data.map((item, idx) => (
                  <tr key={idx} onDoubleClick={() => Update(item)}>
                    <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                    <td>{item.WantedWork}</td>
                    <td>{item.Destination}</td>
                    <td>{item.Result}</td>
                    <td>
                      {" "}
                      {item.FileUrl !== null ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                            onClick={() => handleShowpopup(item.FileUrl)}>
                            {" "}
                            <i className="fa-solid fa-paperclip"></i>
                          </button>
                          <span>{item.FileDescription}</span>
                        </>
                      ) : (
                        " "
                      )}
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => Update(item)}
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleShow(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={ALL ? ALL.TotalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <ToastContainer autoClose={1200} />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      {/* <Modal
        show={showPdf}
        onHide={handleClosePdf}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>بيانات العمل الإداري</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={myDivRefWorkcom}>
            <ManagePrint
       Requirework={Requirework}
       Result ={Result}
       Notes={Notes}
       Description={Description}
       MenueWork ={MenueWork}
       GehaWork  ={GehaWork}
       Datee ={Datee}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleClosePdf}>
            إغلاق
          </Button>
          <Button
            onClick={handlePrint}
            variant="primary"
            className="edit">
            طباعة
          </Button>
        </Modal.Footer>
      </Modal> */}
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer autoClose={1200} />
      </div>
      <div ref={myDivRefWorkcom}>
        <ManagePrint
          Requirework={Requirework}
          Result={Result}
          Notes={Notes}
          Description={Description}
          MenueWork={MenueWork}
          GehaWork={GehaWork}
          Datee={Datee}
        />
      </div>
    </>
  );
};
export default Money;
